export default "__VITE_ASSET__uwEMPaD3__"